
import {of as observableOf,  Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Activity, ListingActivity, ListingActivityViewModel, ListingOption, ListingOptionBundle } from '../models';

@Injectable()
export class ActivityService {
  private readonly _serviceName = 'ActivityService';

  activities: Activity[];

  constructor(private http: HttpClient) {
    this.getActivities().subscribe({
      next: data => {
        this.activities = data;
        console.log(`${this._serviceName} - CTOR - activities set with ${data.length} items.`);
      },
      error: err => {
        console.error(err);
      }
    });
  }

  /**
   * Gets all activity
   *
   */
  get(): Observable<Activity[]> {
    if (this.activities && this.activities.length > 0) {
      console.log(`${this._serviceName} - get - activities data returned from cache.`);
      return observableOf(this.activities);
    } else {
      console.log(`${this._serviceName} - get - activities data returned from web api.`);
      return this.http.get<Activity[]>('activity');
    }
  }

  /**
   * Gets all activities from api/activity
   */
  private getActivities(): Observable<Activity[]> {
    return this.http.get<Activity[]>('activity');
  }

  optionGetAll(): Observable<ListingOptionBundle> {
    return this.http.get<ListingOptionBundle>('listing-options/all');
  }

  optionAdd(listingOption: ListingOption): Observable<ListingOption> {
    return this.http.put<ListingOption>(optionUrl(listingOption), listingOption);
  }

  optionDelete(listingOption: ListingOption): Observable<Response> {
    return this.http.delete<Response>(optionUrl(listingOption));
  }

  optionUpdate(listingOption: ListingOption): Observable<ListingOption> {
    return this.http.put<ListingOption>(optionUrl(listingOption), listingOption);
  }

  activityPersist(listingActivity: ListingActivity) {
    return this.http.put(activityUrl(listingActivity), listingActivity);
  }

  activityDelete(listingActivity: ListingActivity) {
    return this.http.delete(activityUrl(listingActivity));
  }

  /**
   * Gets a list of activity names from a array of Listing Activities
   * @param activities
   */
  getListingActivityNames(activities: ListingActivityViewModel[]): string[] {
    return activities.map(item => item.name);
  }
}

function optionUrl(listingOption: ListingOption): string {
  return `listing-options/${listingOption.listingId}/${listingOption.activityCategoryId}/${listingOption.activityOptionId}`;
}

function activityUrl(listingActivity: ListingActivity): string {
  return `listing/${listingActivity.listingId}/activity/${listingActivity.activityId}`;
}
